/*
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-04-17, 13:00:40
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-04-23, 11:54:26
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'SwitchBox',

  props: {
    service: {
      type: Object,
      default: (() => {}),
    },
  },

  watch: {
    service(newValue) {
      this.selectedValue = newValue.is_active;
    },
  },
  data() {
    return {
      selectedValue: this.service.is_active,
    };
  },

  created() {
  },

  methods: {
    handleChangeValue() {
      this.$emit('changeValue', this.service);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Common/SwitchBox/component.js